import rootStores from '@/Stores/RootStores';

export const useCatalogSelectedFilters = () => {
    const {catalogStore} = rootStores;
    const deleteFilter = catalogStore.deleteFilter;

    const resetAllFilters = catalogStore.resetAllFilters;

    return {
        deleteFilter,
        resetAllFilters,
    };
};
